import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { ScoreWidgetComponent } from '../../../../score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { ScoreTableComponent } from '../../../../score/score-table/score-table.component';
import { LtmsLoaderComponent } from '../../../../ltms-loader/ltms-loader.component';

interface DeviceExportData {
  name: string;
  number_of_user_rated: number;
  percentage: any;
}

@Component({
    selector: 'app-engagement-channel-performance',
    templateUrl: './engagement-channel-performance.component.html',
    styleUrl: './engagement-channel-performance.component.scss',
    imports: [ScoreWidgetComponent, NgIf, ScoreTableComponent, LtmsLoaderComponent]
})
export class EngagementChannelPerformanceComponent implements OnChanges{
  
  @Input() data: any;
  @Input() displayName: string = "";
  @Input() isDataLoaded: boolean = true;
  responseDistribution: any = [];
  responseDistributionFooter: any = []
  responseDistributionHeader = [
    {
      header: "Responses Received",
      dataKey: 'name',
      uniqueId: 'name',
      width: '200px',
      isSorting: false,
      showPercentage: false,
      defaultValue: 0,
      order: "4"
    },
    {
      header: "Count",
      dataKey: 'count',
      uniqueId: 'count',
      width: '120px',
      style: {
        header: "flex-end",
        row: "flex-end"
      },
      isSorting: false,
      showPercentage: false,
      defaultValue: 0,
      order: "4"
    }
  ];
  responseRateDistributionHeader = [{
    header: "Channel",
    dataKey: 'name',
    uniqueId: 'name',
    width: '200px',
    isSorting: false,
    showPercentage: false,
    defaultValue: 0,
    order: "4"
  },
  {
    header: "Value (%)",
    dataKey: 'percentage',
    uniqueId: 'percentage',
    width: '120px',
    style: {
      header: "flex-end",
      row: "flex-end"
    },
    isSorting: false,
    showPercentage: false,
    defaultValue: 0,
    order: "4"
  }];
  constructor( private engagementService: EngagementService, private _analytics: ResponseAnalyticsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.responseDistribution = this.getResponseReceivedDetails(this.data?.current)
    const responseCount = this.data?.current?.number_of_request_generated_rated ? this.data?.current?.number_of_request_generated_rated : 0;
    this.responseDistributionFooter = [{
      name: "Total",
      count: this.engagementService.formatNumber(responseCount),
      percentage: this.engagementService.getResponeRate(this.data?.current)
    }]
  }
   // Method for getting Response Received Details
   getResponseReceivedDetails(current: any): any[] {
    let resRecexportData: any[] = [];
    const mapping: { [key: string]: string } = {
      "sms": "SMS",
      "email": "Email",
      "link": "Link",
      "whatsapp": "WhatsApp",
      "qrcode": "QR Code",
      "kiosk_link": "Kiosk Link",
      "all": "All"
    };

    try {
      if (current?.response_by_channel_overall && Object.keys(current.response_by_channel_overall).length > 0) {
        Object.keys(current.response_by_channel_overall).forEach((chnl, index) => {
          const cChnl = chnl;
          const channelName = mapping[cChnl.toLowerCase()] ? mapping[cChnl.toLowerCase()] : cChnl;
          const count = current?.response_by_channel_overall[cChnl]?.count ?? 0
          resRecexportData.push({
            "name": `${channelName}`,
            "field_id": `response_by_channel_${cChnl}`,
            "count": this.engagementService.formatNumber(count),
            "percentage": this.getResponseRatePercentage(current, cChnl),
            "click_disabled": true,
            "indentation_level": 1
          });
        });
      }
    } catch (err) {
      console.error("Error in getResponseReceivedDetails: ", err);
    }

    return resRecexportData;
  }
  
  getResponseRatePercentage(data: any, channel: string): string {
    const chnl = channel.toString().toLowerCase();
    const deliveredRequests = data.request_delivered_by_channels[chnl]?.delivered || 0;
    const responses = data.response_by_channel_overall[channel]?.count || 0;
    const percentage = (deliveredRequests > 0) ? (responses / deliveredRequests) * 100 : 0;
    return `${percentage.toFixed(2)}`;
  }
  scoreWidget(type: string): any {
    return {
      isDownloadButtonShow: true
    };
  }
  onDownload(name) {
      let downloadConfig: any = {
        dataKey: 'uniqueId',
        headerKey: 'header',
        data: [{
          columns: (name == "Channel-wise Response Distribution") ? this.responseDistributionHeader : this.responseRateDistributionHeader,
          rows: [...this.responseDistribution, ...this.responseDistributionFooter]
        }]
      }
      downloadConfig.fileDetails = {
        title: this.displayName ? 'Engagement Summary - ' + name + " - " + this.displayName: 'Engagement Summary - ' + name,
        fileName: 'Engagement Summary - ' + name,
        accountName: Helpers?.accountDetails?.display_name || 'NA',
        brandName: Helpers?.brandDetails?.name || ""
      }

      if (downloadConfig.data.length) {
        this._analytics.prepareAndDownloadData(downloadConfig);
      }
  }
}

